import {useTranslation} from "react-i18next";
import {useLazyDownloadAssetClimateChangeQuery} from "../../../../redux/api/asset";
import {useMessageContext} from "../../../../context/message/MessageContext";
import {capitalize} from "lodash";
import PermissionRoute from "../../../Authentication/PermissionRoute";
import {isClimateChangeViewReportsCreation} from "../../../Authentication/permissions";
import {Button, ButtonProps} from "antd";
import {DownloadOutlined} from "@ant-design/icons";

export default function ClimateChangeReportDownload({assetUuid, buttonProps}: {
  assetUuid: string,
  buttonProps?: ButtonProps
}) {

  const {t} = useTranslation()
  const [download, {isFetching}] = useLazyDownloadAssetClimateChangeQuery()
  const setAntdMessage = useMessageContext()
  const handleDownload = async () => {
    try {
      await download({
        assetUuid,
      }).unwrap()
      setAntdMessage({
        success: capitalize(t('documents.downloadSuccess'))
      })
    } catch {
      setAntdMessage({
        error: capitalize(t('documents.downloadError'))
      })
    }
  }

  return <PermissionRoute isAuthorized={isClimateChangeViewReportsCreation}>
    <Button
      type={"default"}
      style={{width: "100%"}}
      icon={<DownloadOutlined/>}
      disabled={isFetching}
      loading={isFetching}
      onClick={handleDownload}
      children={capitalize(t("actions.downloadItem", {item: t('misc.report')}))}
      {...buttonProps}
    />
  </PermissionRoute>

}